export default {
  "b2b.zadosti-grid-columns.doplnkoveSluzby.label": "Doplňkové služby",
  "b2b.zadosti-grid-columns.posledniAktivita.label": "Poslední aktivita",
  "b2b.zadosti-grid-columns.projekt.label": "Projekt",
  "b2b.zadosti-grid-columns.termin.label": "Termín",
  "b2b.zadosti-grid-columns.zadavatel.label": "Zadavatel",
  "b2b.zadosti-grid-columns.zdroj.label": "Zdroj",
  "b2b.zadosti-grid-columns.kolize.label": "Kolize",
  "b2b.zadosti-grid-columns.fixni.label": "Fixni",
  "b2b.zadosti-grid-columns.datum-vytvoreni.label": "Vytvoření",
  "b2b.zadosti-grid-columns.stav.label": "Stav"
};
